import React from "react";
import { NOT_FOUND_CONTENT } from "../../constants";
import { Button } from "../atoms";

import "./not-found.m.css";

const NotFoundPage = () => {
  const {status, notFoundDescription, notFoundMessage, backToHome} = NOT_FOUND_CONTENT;

  return (
    <div className="container" styleName="not-found-container">
      <div styleName="status">{status}</div>
      <div styleName="message">{notFoundMessage}</div>
      <div styleName="description">{notFoundDescription}</div>
      <Button href="/">{backToHome}</Button>
    </div>
  );
};

export { NotFoundPage };
